import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {InvoiceSummaryReportData} from "./invoice-summary-report.data";

@Injectable()
export class InvoiceSummaryReportModel extends ReportModel<InvoiceSummaryReportData> {
    constructor(injector: Injector) {
        super(injector, InvoiceSummaryReportData);
    }
}
